/**
 * @generated SignedSource<<56f53e4665ae514795f9a0ffaa7f4930>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateVisibility = "GLOBAL" | "HIDDEN" | "USER" | "WORKSPACE";
export type modalBrowseNoteTemplatesQuery$variables = {};
export type modalBrowseNoteTemplatesQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToPromptHeadings: boolean;
        readonly hasAccessToWorkspaceTemplates: boolean;
        readonly subscriptionProductName: string;
      };
    };
    readonly canCreateWorkspaceTemplate: boolean;
    readonly id: string;
    readonly noteTemplates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly author: {
            readonly fullName?: string;
            readonly iconName?: string | null;
            readonly name?: string;
          } | null;
          readonly id: string;
          readonly starred: boolean;
          readonly summary: string;
          readonly tags: ReadonlyArray<string>;
          readonly title: string;
          readonly updatedAt: string;
          readonly viewerAppliedAt: string | null;
          readonly visibility: TemplateVisibility;
          readonly " $fragmentSpreads": FragmentRefs<"GridNoteTemplates">;
        };
      }>;
    };
  };
};
export type modalBrowseNoteTemplatesQuery = {
  response: modalBrowseNoteTemplatesQuery$data;
  variables: modalBrowseNoteTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canCreateWorkspaceTemplate",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionProductName",
  "storageKey": null
},
v3 = {
  "alias": "hasAccessToWorkspaceTemplates",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "templates"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"templates\")"
},
v4 = {
  "alias": "hasAccessToPromptHeadings",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "prompt_headings"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"prompt_headings\")"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "starred",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerAppliedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "alias": "iconName",
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v21 = [
  (v12/*: any*/),
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "modalBrowseNoteTemplatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "noteTemplates",
            "args": null,
            "concreteType": "NoteTemplateConnection",
            "kind": "LinkedField",
            "name": "__Browse_noteTemplates_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteTemplateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteTemplateNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "TemplateUserAuthor",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "TemplateCompanyAuthor",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/)
                            ],
                            "type": "TemplateIconAuthor",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "Account",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "ExternalAccount",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*: any*/)
                            ],
                            "type": "User",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "GridNoteTemplates"
                      },
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "modalBrowseNoteTemplatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteTemplateConnection",
            "kind": "LinkedField",
            "name": "noteTemplates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteTemplateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteTemplateNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v12/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": "fullName",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              }
                            ],
                            "type": "TemplateUserAuthor",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v12/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "darkModeLogo",
                                "storageKey": null
                              }
                            ],
                            "type": "TemplateCompanyAuthor",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "icon",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              {
                                "alias": "nameThatIsOptional",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              }
                            ],
                            "type": "TemplateIconAuthor",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "Account",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "ExternalAccount",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*: any*/),
                              (v0/*: any*/),
                              (v19/*: any*/)
                            ],
                            "type": "User",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v0/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isNoteTemplateAuthor"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "viewerCanEdit",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appliedCount",
                        "storageKey": null
                      },
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "Browse_noteTemplates",
            "kind": "LinkedHandle",
            "name": "noteTemplates"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "687089516627139b12ad296604ad0e65",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "viewer",
            "noteTemplates"
          ]
        }
      ]
    },
    "name": "modalBrowseNoteTemplatesQuery",
    "operationKind": "query",
    "text": "query modalBrowseNoteTemplatesQuery {\n  viewer {\n    id\n    canCreateWorkspaceTemplate\n    account {\n      billingAccount {\n        subscriptionProductName\n        hasAccessToWorkspaceTemplates: hasAccessToFeature(feature: templates)\n        hasAccessToPromptHeadings: hasAccessToFeature(feature: prompt_headings)\n        id\n      }\n      id\n    }\n    noteTemplates {\n      edges {\n        node {\n          id\n          title\n          starred\n          summary\n          tags\n          updatedAt\n          viewerAppliedAt\n          visibility\n          author {\n            __typename\n            ... on TemplateUserAuthor {\n              name\n            }\n            ... on TemplateCompanyAuthor {\n              name\n            }\n            ... on TemplateIconAuthor {\n              iconName: name\n            }\n            ... on Account {\n              name\n            }\n            ... on ExternalAccount {\n              name\n            }\n            ... on User {\n              fullName\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          ...GridNoteTemplates\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment GridElementTemplate on NoteTemplateNode {\n  id\n  viewerCanEdit\n  starred\n  visibility\n  ...TemplateCardFullsizeNoteTemplate\n}\n\nfragment GridNoteTemplates on NoteTemplateNode {\n  id\n  ...GridElementTemplate\n}\n\nfragment StarButtonNoteTemplate on NoteTemplateNode {\n  id\n  starred\n}\n\nfragment TemplateAuthor_Author on NoteTemplateAuthor {\n  __isNoteTemplateAuthor: __typename\n  __typename\n  ... on User {\n    id\n    fullName\n    image\n  }\n  ... on Account {\n    name\n    logo\n  }\n  ... on ExternalAccount {\n    name\n    logo\n  }\n  ... on TemplateUserAuthor {\n    image\n    fullName: name\n  }\n  ... on TemplateCompanyAuthor {\n    name\n    logo\n    darkModeLogo\n  }\n  ... on TemplateIconAuthor {\n    icon\n    color\n    nameThatIsOptional: name\n  }\n}\n\nfragment TemplateCardFullsizeNoteTemplate on NoteTemplateNode {\n  title\n  starred\n  summary\n  appliedCount\n  author {\n    __typename\n    ...TemplateAuthor_Author\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...StarButtonNoteTemplate\n}\n"
  }
};
})();

(node as any).hash = "4b93f45c16ce6f5d7911b64f244e1752";

export default node;
